import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class FinancialFileService {

    constructor(private http: HttpClient) { }

    upload(key: string, file: File, cannedAcl: 'Private' | 'PublicRead' = 'Private'): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('key', key);
        formData.append('cannedAcl', cannedAcl);
        return this.http.post(`api/financial/file/upload`, formData, { responseType: 'text' });
    }

    download(key: string): Observable<any> {
        const formData = new FormData();
        formData.append('key', key);
        return this.http.post(`api/financial/file/download`, formData, {
            observe: 'response',
            responseType: 'blob' as 'json'
        });
    }

    delete(key: string): Observable<boolean> {
        const formData = new FormData();
        formData.append('key', key);
        return this.http.post(`api/financial/file/delete`, formData).pipe(
            map(_ => true),
            catchError(_ => of(false))
        );
    }

}
